import {axiosInstance as mantis} from "./mantis";

export const getLoggedUserProfile = () => {
    return mantis.get("/profile");
};

export const changeLoggedUserPassword = (oldPassword, password) => {
    const data = {oldPassword, password};
    return mantis.put("/profile/password", data);
};

export const updateLanguagePreference = (language) => {
    return mantis.patch("/profile/language", {language});
};
